var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnanswered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9034 24.5V23.733L19.7841 20.5795C20.1222 20.2102 20.4006 19.8892 20.6193 19.6165C20.8381 19.3409 21 19.0824 21.1051 18.8409C21.2131 18.5966 21.267 18.3409 21.267 18.0739C21.267 17.767 21.1932 17.5014 21.0455 17.277C20.9006 17.0526 20.7017 16.8793 20.4489 16.7571C20.196 16.6349 19.9119 16.5739 19.5966 16.5739C19.2614 16.5739 18.9688 16.6435 18.7188 16.7827C18.4716 16.919 18.2798 17.1108 18.1435 17.358C18.0099 17.6051 17.9432 17.8949 17.9432 18.2273H16.9375C16.9375 17.7159 17.0554 17.267 17.2912 16.8807C17.527 16.4943 17.848 16.1932 18.2543 15.9773C18.6634 15.7614 19.1222 15.6534 19.6307 15.6534C20.142 15.6534 20.5952 15.7614 20.9901 15.9773C21.3849 16.1932 21.6946 16.4844 21.919 16.8509C22.1435 17.2173 22.2557 17.625 22.2557 18.0739C22.2557 18.3949 22.1974 18.7088 22.081 19.0156C21.9673 19.3196 21.7685 19.6591 21.4844 20.0341C21.2031 20.4062 20.8125 20.8608 20.3125 21.3977L18.3523 23.4943V23.5625H22.4091V24.5H16.9034Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnanswered);
export default __webpack_public_path__ + "static/media/unanswered.28ea917a1acff4f28e75e233ea1809c1.svg";
export { ForwardRef as ReactComponent };